import format from 'date-fns/format'

import i18n from '../../../i18n'
import { Language } from '../../consts'

export default function (date: string | Date, language: Language): string {
  const dateFormatStr = i18n.t('date_format', { lng: language })
  return format(new Date(date), dateFormatStr)
}
